/** Default whitelist — must match strings returned by X AboutAccountQuery (account_based_in). */
export const DEFAULT_SCRAPER_COUNTRY_WHITELIST = [
  'Australia', 'Austria', 'Belgium', 'Canada', 'Denmark', 'Finland', 'France', 'Germany',
  'Ireland', 'Italy', 'Luxembourg', 'Netherlands', 'New Zealand', 'Norway', 'Spain',
  'Switzerland', 'United Kingdom', 'United States', 'Poland',
  'Portugal', 'North America', 'Monaco', 'Malta',
];

export const SCRAPER_ACTIVE_PERIOD_OPTIONS = [
  { label: 'Last 7 days', days: 7 },
  { label: 'Last 14 days', days: 14 },
  { label: 'Last month (30 days)', days: 30 },
  { label: 'Last 60 days', days: 60 },
  { label: 'Last 90 days', days: 90 },
];

/**
 * Auto-source SOURCE-account gates (not follower filters).
 * 3k–30k, drop Blue — near 5% follow-back with enough volume to keep
 * discovery fed. 0 min / 0 max means that bound is off.
 */
export const RECOMMENDED_AUTO_SOURCE_GATES = {
  autoSourceMinFollowers: 3000,
  autoSourceMaxFollowers: 29999,
  autoSourceRejectBlue: true,
  autoSourceRequireLinks: true,
};

/** Default approved bio-link destinations for deep link scan — mirrors backend list. */
export const DEFAULT_DEEP_LINK_PLATFORM_HOSTS = [
  'onlyfans.com',
  'fansly.com',
  'fanvue.com',
  'loyalfans.com',
  'justfor.fans',
  'mym.fans',
  'fancentro.com',
  'admireme.vip',
  'manyvids.com',
  'exclu.at',
  'privacy.com.br',
  'passes.com',
  '4based.com',
  'ismygirl.com',
  'slushy.com',
  'stars.avn.com',
  't.me',
  'telegram.me',
];

export function normalizeDeepLinkPlatformHost(raw) {
  let s = String(raw || '').trim().toLowerCase();
  if (!s) return '';
  s = s.replace(/^https?:\/\//, '').replace(/^www\./, '');
  return s.split('/')[0].split('?')[0];
}

export function formatFollowerCount(n) {
  if (n == null || n === '' || !Number.isFinite(Number(n))) return '—';
  const v = Number(n);
  if (v >= 1000) return `${Math.round(v / 100) / 10}k`;
  return String(Math.round(v));
}

export function formatAutoSourceBand(filters) {
  const min = Number(filters?.autoSourceMinFollowers) || 0;
  const max = Number(filters?.autoSourceMaxFollowers) || 0;
  const rejectBlue = Boolean(filters?.autoSourceRejectBlue);
  let band = 'any size';
  if (min > 0 && max > 0) band = `${formatFollowerCount(min)}–${formatFollowerCount(max)}`;
  else if (min > 0) band = `${formatFollowerCount(min)}+`;
  else if (max > 0) band = `up to ${formatFollowerCount(max)}`;
  if (rejectBlue) band += ' · drop Blue';
  if (filters?.autoSourceRequireLinks !== false) band += ' · link in bio';
  return band;
}

export function prettyProfileUrl(url) {
  const raw = String(url || '').trim();
  if (!raw) return '';
  return raw.replace(/^https?:\/\//i, '').replace(/^www\./i, '').replace(/\/$/, '');
}
